<template>
  <div
    v-show="curMenu > 0"
    class="side-section"
    :class="{ on: isOpen, off: !isOpen }"
  >
    <a
      href="javascript:;"
      class="qa-btn"
      :class="{ on: isOpen, off: !isOpen }"
      @click="handlerQa"
    >
      问卷调查
    </a>
    <span
      class="side-btn"
      :class="{ on: isOpen, off: !isOpen }"
      @click="handlerOpen"
    ></span>
    <div class="side-bar">
      <div class="top">
        <a
          href="javascript:;"
          class="side-item and-down"
          @click="downFun('and')"
        />
        <a
          href="javascript:;"
          class="side-item app-down"
          @click="downFun('ios')"
        />
        <div class="side-code">
          <img :src="contact.wxQr" />
          <p class="side-txt">扫码关注微信公众号</p>
        </div>
      </div>
    </div>
    <menu-bar @moveTo="moveTo"></menu-bar>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Common from "./Common";
import MenuBar from "@/components/MenuBar";
export default {
  name: "Siderbar",
  components: {
    MenuBar
  },
  mixins: [Common],
  data() {
    return {
      isOpen: true
    };
  },
  computed: {
    ...mapState(["contact", "curPage"]),
    curMenu() {
      return this.curPage < 6 ? this.curPage : -1;
    }
  },
  methods: {
    ...mapActions(["setShowQR"]),
    moveTo(page) {
      this.$emit("moveTo", page);
    },
    handlerQa() {
      this.$toast({
        message: "敬请期待",
        duration: 1000
      });
    },
    handlerOpen() {
      this.isOpen = !this.isOpen;
    },
    showQR() {
      this.setShowQR(true);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.side-section {
  position: fixed;
  top: 100px;
  right: 0;
  z-index: 2;
  width: 173px;
  transition: all 0.4s ease;
  .transform(translateX(173px));
  &.on {
    .transform(translateX(0px));
  }
  &.off {
    .transform(translateX(173px));
  }
}
.qa-btn {
  position: absolute;
  top: -128px;
  right: 4px;
  display: none;
  width: 215px;
  height: 128px;
  text-indent: -9999px;
  cursor: pointer;
  background: url("~@/assets/images/qa.png") no-repeat;
  background-size: 100% 100%;
  transition: all 0.4s ease;
  .transform(translateX(218px));
  &.on {
    .transform(translateX(0px));
  }
  &.off {
    .transform(translateX(218px));
  }
}
.side-bar {
  display: block;
  width: 100%;
  height: 331px;
  padding-top: 20px;
  background:
    url("~@/assets/images/siderbar/siderbarbg.png") no-repeat left top /
    100%;
}

.side-btn {
  position: absolute;
  top: 0;
  left: -22px;
  width: 23px;
  height: 70px;
  cursor: pointer;
  background: url("~@/assets/images/sq.png") no-repeat left top / 100%;
  transition: all 0.5s ease;
  &.off {
    background: url("~@/assets/images/zk.png") no-repeat left top / 100%;
  }
}
.side-item {
  display: block;
  width: 146px;
  height: 44px;
  margin: 0 auto;
  .transition(0.4s);
  &:hover {
    .transform(scale(1.04));
  }
  &.and-down {
    background:
      url("~@/assets/images/siderbar/androidbtn.png") no-repeat left
      top / 100%;
  }
  &.app-down {
    margin-top: 12px;
    background:
      url("~@/assets/images/siderbar/iosbtn.png") no-repeat left top /
      100%;
  }
  &.home-btn {
    margin-top: 30px;
    background:
      url("~@/assets/images/siderbar/homebtn.png") no-repeat left top /
      100%;
  }
}
.side-txt {
  margin-top: 7px;
  font-size: 16px;
  color: #c9c9d1;
  text-align: center;
}
.side-code {
  margin-top: 24px;
  img {
    display: block;
    width: 150px;
    height: 150px;
    margin: 0 auto;
  }
}

@media screen and (max-height: 1000px) {
  .side-section {
    top: 40px;
    right: -30px;
    &.on {
      transform: translateX(-13px) translateZ(0) scale(0.8);
    }
    &.off {
      transform: translateX(125px) translateZ(0) scale(0.8);
    }
  }
}

@media screen and (max-height: 750px) {
  .side-section {
    top: -15px;
    right: -30px;
    &.on {
      transform: translateX(-4px) translateZ(0) scale(0.7);
    }
    &.off {
      transform: translateX(116px) translateZ(0) scale(0.7);
    }
  }
}
.bak {
  .side-section {
    .mixin_com(top, 100);
    .mixin_com(right, 0);
    .mixin_com(width, 173);
    .mixin_com(height, 410);
    .mixin_trans(173);
    &.off {
      .mixin_trans(173);
    }
  }
  .qa-btn {
    .mixin_com(right, 4);
    .mixin_com(top, -128);
    .mixin_com(width, 215);
    .mixin_com(height, 128);
    .mixin_trans(218);
    &.on {
      .mixin_trans(0);
    }
    &.off {
      .mixin_trans(218);
    }
  }
  .side-bar1 {
    .mixin_bg_size(173, 331);
    .mixin_com(height, 331);
    .mixin_com(padding-top, 24);
  }
  .side-btn {
    .mixin_bg_size(23, 70);
    .mixin_com(left, -22);
    .mixin_com(width, 23);
    .mixin_com(height, 70);
  }
  .side-item {
    .mixin_com(width, 146);
    .mixin_com(height, 44);
    &.app-down {
      .mixin_com(margin-top, 16);
    }
    &.home-btn {
      .mixin_com(margin-top, 30);
    }
  }
  .side-txt {
    .mixin_com(font-size, 16);
    .mixin_com(margin-top, 7);
  }
  .side-code {
    .mixin_com(margin-top, 24);
    img {
      .mixin_com(width, 180);
      .mixin_com(height, 180);
    }
  }
}
</style>
